import { styled } from '@linaria/react';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;

  /*
    Weirdly, the box can shift 1 pixel depending on the size
    of the <Code> element. To prevent this, give the container
    a larger minimum width, so that it doesn't change when
    the code sample changes.
  */
  @media (min-width: 550px) {
    min-width: 475px;
  }
`;

export default Wrapper;
